module.exports = __webpack_public_path__ + "fonts/frame_137_2.svg";